import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import { useProjects } from '../../../hooks/useProjects';
import { toast } from 'react-toastify';

const HomeItem = () => {
  const { projects, isLoading, error } = useProjects();

  useEffect(() => {
    if (error) {
      toast.error(`Erreur lors du chargement des projets: ${error}`);
    }
  }, [error]);

  const convertText = (text) => {
    if (!text) return text;
    let convertedText = text.replace(/_/g, ' ').toLowerCase();
    convertedText = convertedText.charAt(0).toUpperCase() + convertedText.slice(1);
    return convertedText;
  }

  // Fonction pour vérifier si l'URL est une image directe
  const isImageUrl = (url) => {
    if (!url) return false;
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg'];
    return imageExtensions.some(ext => url.toLowerCase().includes(ext));
  };

  if (isLoading) {
    return (
      <div className="col-12 text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Chargement...</span>
        </div>
      </div>
    );
  }

  // Vérifier que projects est un tableau
  const projectsArray = Array.isArray(projects) ? projects : [];
  
  if (projectsArray.length === 0) {
    return (
      <div className="col-12 text-center">
        <p className="text-muted">Aucun projet disponible</p>
      </div>
    );
  }

  return (
    <>
      {projectsArray.map((project) => (
        // <div key={project.id} className="col-3 navigate" style={{ marginBottom: 24, position: "relative", zIndex: 0 }}>
        //   <Link to={`/projet/${project.id}/etape/cadrage`}>
        //     <div style={{ position: "relative" }}>
        //       <img
        //         src={isImageUrl(project.link_url) ? project.link_url : "/assets/images/Solivage-plancher.png"}
        //         className=""
        //         alt={project.nom || project.name}
        //         style={{ maxWidth: "100%" }}
        //         onError={(e) => {
        //           // Si l'image ne charge pas, utiliser l'image par défaut
        //           e.target.src = "/assets/images/Solivage-plancher.png";
        //         }}
        //       />
        //     </div>
        //     <div className="rectangle container pt-3 pb-3" style={{ zIndex: 1, bottom: 0 }}>
        //       {/* <p className="Card-sub-title lh-1" style={{ zIndex: 2 }}>
        //         [Projet]
        //       </p> */}
        //       <p className="Card-title" style={{ opacity: 1, zIndex: 2 }}>
        //         {convertText(project.nom || project.name) || project.nom || project.name}
        //       </p>
        //     </div>
        //   </Link>
        // </div>
        <div key={project.id} class="col-6 col-md-3 mb-4">
        {/* <div key={project.id} className="col-6 col-md-3 mb-4 navigate" style={{ marginBottom: 24, position: "relative", zIndex: 0 }}> */}
          <Link to={`/projet/${project.id}/etape/cadrage`}>
          <label style={{width: "100%", cursor: "pointer"}}>
            {/* <input type="radio" name="materiau" value={project.id} className="materiau-radio"/> */}
            <div className="materiau-wrapper" style={{ borderRadius: 0, width:"100%", overflow: "hidden", position: "relative", zIndex: 0, height: "225px" }}>
              <img
                // src={isImageUrl(project.link_url) ? project.link_url : "/assets/images/Solivage-plancher.png"} 
                src={project.image || "/assets/images/Solivage-plancher.png"}
                alt={project.nom || project.name} 
                style={{ maxWidth: "auto", height: "251px", width: "100%"}}
                loading='lazy'
                onError={(e) => {
                  // Si l'image ne charge pas, utiliser l'image par défaut
                  e.target.src = "/assets/images/Solivage-plancher.png";
                }}
              />
              <div className="rectangle px-4 py-1">
                <p className="Card-title text-ellipsis">{convertText(project.nom || project.name) || project.nom || project.name}</p>
                <p className="Card-sub-title text-ellipsis" style={{opacity: 1, zIndex: 2}}>{project.description}</p>
              </div>
            </div>
          </label>
          </Link>
        </div>
      ))}
    </>
  );
}

export default HomeItem